import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnDestroy,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription, throwError } from 'rxjs';
import { tap, catchError, takeUntil, skip } from 'rxjs/operators';

import { FileTypeConstant } from '@app/core/_constant/index.constants';
import { AuthService } from '@app/core/auth';
import { ReceivingReportService } from '@app/core/purchase-orders/services/receiving-report.service';
import { RfqLotService } from '@app/core/rfq-lots/services/rfq-lots.service';
import { RfqLotLabel } from '@app/core/rfq-lots/store/rfq-lots.model';
import {
  ReceivingReportInterface,
  ReceivingReportRfqInterface,
} from '@app/interfaces/receiving-report.interface';

@Component({
  selector: 'cnc-print-label',
  templateUrl: './print-label.component.html',
  styleUrls: ['./print-label.component.scss'],
})
export class PrintLabelComponent implements OnInit, OnDestroy {
  @Input()
  receivingReport :ReceivingReportInterface;

  rrItems :ReceivingReportRfqInterface[] = [];
  pageTitle :string = 'Print Labels';
  rfqLotSubscription :Subscription;
  fileType = FileTypeConstant;
  rrItemsWithoutLot :string[] = [];
  private onDestroy$ = new Subject();

  constructor(
    public activeModal :NgbActiveModal,
    public receivingReportSvc :ReceivingReportService,
    private cd :ChangeDetectorRef,
    public authService :AuthService,
    public rfqLotSvc :RfqLotService,
    private toastr :ToastrService,
  ) {}

  ngOnInit() :void {
    this.loadRRItems();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  loadRRItems() :void {
    if (this.receivingReport.receiving_report_rfq?.length > 0) {
      this.receivingReport.receiving_report_rfq?.forEach((rrItem) => {
        if (rrItem.lot_id > 0) {
          this.rrItems.push(rrItem);
        } else {
          this.rrItemsWithoutLot.push(
            rrItem?.purchase_order_rfq?.product_name ?? 'N/A',
          );
        }
      });
    }
  }

  export(type :string = 'pdf') :void {
    this.rfqLotSvc
      .exportLabel({
        items: this.convertToLabelPayload(),
        type: type,
      })
      .pipe(
        catchError((response) => {
          this.toastr.error(response.error);

          return throwError(response.error);
        }),
        takeUntil(this.onDestroy$),
      )
      .subscribe((response) => {
        this.rfqLotSvc.downloadFile(
          new Blob([response]),
          'ReceivingReportLabel.' + type,
        );
        this.toastr.success('Successfully printed label!');
        this.activeModal.close();
      });
  }

  convertToLabelPayload() :RfqLotLabel[] {
    const items = [];
    this.rrItems.forEach((item) => {
      items.push({
        product_name: item?.purchase_order_rfq?.product_name ?? '',
        lot_number: item?.rfq_lot?.lot_number ?? '',
        quantity: item?.quantity ?? 0,
      });
    });

    return items;
  }

  get rrItemsWithoutLotData() :string {
    return this.rrItemsWithoutLot.join(', ');
  }
}
